var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57574 5.57574C2.34142 5.81005 2.34142 6.18995 2.57574 6.42426L6.39411 10.2426C6.62843 10.477 7.00833 10.477 7.24264 10.2426C7.47696 10.0083 7.47696 9.62843 7.24264 9.39411L3.84853 6L7.24264 2.60589C7.47696 2.37157 7.47696 1.99167 7.24264 1.75736C7.00833 1.52304 6.62843 1.52304 6.39411 1.75736L2.57574 5.57574ZM10.5 6.6C10.8314 6.6 11.1 6.33137 11.1 6C11.1 5.66863 10.8314 5.4 10.5 5.4V6.6ZM3 6.6H10.5V5.4H3V6.6Z",
    fill: "#ACBED2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V11",
    stroke: "#ACBED2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIn);
export default __webpack_public_path__ + "static/media/CollapseIn.4da45b8921905abe3e7e800360749011.svg";
export { ForwardRef as ReactComponent };